<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Deposit from "./Deposit.vue";
import Withdraw from "./Withdraw.vue";
import Transfer from "./Transfer.vue";

import { mapGetters } from "vuex";
import filter from "lodash/filter";

export default {
  page: {
    title: "Ví",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Deposit, Withdraw, Transfer },
  data() {
    return {
      title: "Ví",
      items: [
        {
          text: "Hệ Thống",
          href: "/",
        },
        {
          text: "Ví",
          active: true,
        },
      ],
      coinActive: null,
    };
  },
  computed: {
    ...mapGetters({
      UserInfo: "user/UserInfo",
      Coin: "wallet/Coin",
      Rate: "wallet/Rate",
      Balance: "wallet/Balance",
    }),
    NotVND() {
      return filter(this.Coin, (elm) => elm.Currency_Name !== "VND");
    },
  },
  methods: {
    showDeposit(coin) {
      this.coinActive = coin;
      this.$bvModal.show("deposit");
    },
    showWithdraw(coin) {
      this.coinActive = coin;
      this.$bvModal.show("withdraw");
    },
    showTransfer(coin) {
      this.coinActive = coin;
      this.$bvModal.show("transfer");
    },
  },
  created() {
    this.$store.dispatch("wallet/req_getBalance");
    this.unsubscribe = this.$store.subscribe((mutation) => {
      // eslint-disable-next-line default-case
      switch (mutation.type) {
        case "wallet/TRANSFER_SUCCESS":
          this.$bvModal.hide("transfer");
          break;
        case "wallet/WITHDRAW_SUCCESS":
          this.$bvModal.hide("withdraw");
          break;
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body">
            <div>
              <div class="mb-4 me-3">
                <i class="mdi mdi-account-circle text-primary h1"></i>
              </div>

              <div>
                <h5>{{ UserInfo.name }}</h5>
                <p class="text-muted fw-medium mb-0">
                  Mã Định Danh:
                  <span class="text-white font-size-16 ms-1">{{
                    UserInfo.id
                  }}</span>
                </p>
                <p class="text-muted fw-medium mb-1">
                  Email:
                  <span class="text-white font-size-16 ms-1">{{
                    UserInfo.email
                  }}</span>
                </p>
                <p class="text-muted fw-medium mb-1">
                  Tên Đăng Nhập:
                  <span class="text-white font-size-16 ms-1">{{
                    UserInfo.userName
                  }}</span>
                </p>
              </div>
            </div>
          </div>

          <div class="card-body border-top">
            <div class="row">
              <div class="cols-12">
                <div class="text-center d-flex align-items-baseline">
                  <p class="fw-medium mb-2 me-2 text-success font-size-16">Số Dư USD</p>
                  <h4>
                    {{ TruncateToDecimals(parseFloat(Balance.USD), "", 3) }}
                    <span class="font-size-16">$</span>
                  </h4>
                </div>
                <div class="text-center d-flex align-items-baseline">
                  <h5>
                    ~{{
                      TruncateToDecimals(
                        parseFloat(Balance.USD) * parseFloat(Rate[10]),
                        "",
                        3
                      )
                    }}
                    <span class="font-size-16">VND</span>
                  </h5>
                </div>
              </div>
              <div class="cols-12  border-top pt-2 mt-2">
                <div class="text-center d-flex align-items-baseline">
                  <p class="fw-medium mb-2 me-2 text-warning font-size-15">Hoa Hồng VND</p>
                  <h5>
                    {{
                      TruncateToDecimals(
                        parseFloat(Balance.Commission.VND),
                        "",
                        3
                      )
                    }}
                    <span class="font-size-16">đ</span>
                  </h5>
                </div>
              </div>
              <div class="cols-12">
                <div class="text-center d-flex align-items-baseline">
                  <p class="fw-medium mb-2 me-2 text-warning font-size-15">Hoa Hồng USD</p>
                  <h5>
                    {{
                      TruncateToDecimals(
                        parseFloat(Balance.Commission.USD),
                        "",
                        3
                      )
                    }}
                    <span class="font-size-16">$</span>
                  </h5>
                </div>
              </div>
              <div class="cols-12 border-top pt-2 mt-2">
                <div class="text-center d-flex align-items-baseline">
                  <p class="fw-medium mb-2 me-2 text-danger font-size-15">Lãi VND</p>
                  <h5>
                    {{
                      TruncateToDecimals(parseFloat(Balance.Profit.VND), "", 3)
                    }}
                    <span class="font-size-16">đ</span>
                  </h5>
                </div>
              </div>
              <div class="cols-12">
                <div class="text-center d-flex align-items-baseline">
                  <p class="fw-medium mb-2 me-2 text-danger font-size-15">Lãi USD</p>
                  <h5>
                    {{
                      TruncateToDecimals(parseFloat(Balance.Profit.USD), "", 3)
                    }}
                    <span class="font-size-16">$</span>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div>
            <div class="row">
              <div class="col-lg-9 col-sm-8">
                <div class="p-4">
                  <h5 class="text-primary">Chào mừng đã trờ lại !</h5>
                  <p>Ví Tiền Pi Investment</p>

                  <div class="text-muted">
                    <p class="mb-1">
                      <i
                        class="mdi mdi-circle-medium align-middle text-primary me-1"
                      ></i>

                      Để rút tiền bạn cần cập nhật mốc nhận tiền (cập nhật
                      <router-link
                        :to="{ name: 'Profile', query: { type: '5' } }"
                      >
                        tại đây
                      </router-link>
                      ), riêng số dư VND bạn cần cập nhật thêm tài khoản ngân
                      hàng (cập nhật
                      <router-link
                        :to="{ name: 'Profile', query: { type: '4' } }"
                      >
                        tại đây
                      </router-link>
                      ) để chúng tôi có thể thanh toán cho bạn.
                    </p>
                    <p class="mb-1">
                      <i
                        class="mdi mdi-circle-medium align-middle text-primary me-1"
                      ></i>
                      Đối với VND bạn không thể chủ động rút, chúng tôi sẽ
                      chuyển tiền đến tài khoản ngân hàng của bạn khi đến mốc
                      nhận tiền.
                    </p>
                    <p class="mb-0">
                      <i
                        class="mdi mdi-circle-medium align-middle text-primary me-1"
                      ></i>
                      Lãi (VND/USD) và hoa hồng (VND/USD): sau khi đến mốc nhận
                      tiền hệ thống sẽ tự động chuyển vào số dư (VND/USD)
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-sm-4 align-self-center">
                <div>
                  <img
                    src="@/assets/images/crypto/features-img/img-1.png"
                    alt
                    class="img-fluid d-block"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div
            class="col-sm-6 col-lg-4 card-out-coin"
            v-for="coin in Coin"
            :key="coin.Currency_ID"
          >
            <div class="card card-coin border-1 border-warning">
              <div class="card-body">
                <p class="text-warning  fw-medium font-size-15 mb-4">
                  <img
                    :src="coin.Currency_Img"
                    alt=""
                    width="25"
                    class="align-middle mb-0 me-2"
                  />
                  {{ coin.Currency_Name }}
                </p>

                <div class="row">
                  <div class="col-12">
                    <div v-if="coin.Currency_ID != 10">
                      <h5>
                        ~
                        {{
                          TruncateToDecimals(
                            parseFloat(Rate[coin.Currency_ID]),
                            "",
                            3
                          )
                        }}
                        USD = ~
                        {{ TruncateToDecimals(parseFloat(Rate[10]), "", 3) }}
                        VNĐ
                      </h5>
                    </div>
                    <div v-else>
                      <h5>
                        ~
                        {{ TruncateToDecimals(parseFloat(Rate[10]), "", 3) }}
                        VNĐ = ~
                        {{ TruncateToDecimals(parseFloat(Rate[5]), "", 3) }}
                        USD
                      </h5>
                      <p class="text-muted text-truncate mb-0"></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <b-button
                  variant="danger"
                  @click="showWithdraw(coin.Currency_ID)"
                  v-if="coin.status_withdraw == 1"
                >
                  Rút Tiền
                </b-button>
                <b-button
                  variant="primary"
                  @click="showTransfer(coin.Currency_ID)"
                  v-if="coin.status_transfer == 1"
                >
                  Chuyển Tiền
                </b-button>
                <b-button
                  variant="success"
                  @click="showDeposit(coin.Currency_ID)"
                  v-if="coin.status_deposit == 1"
                >
                  Nạp Tiền
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="deposit"
        :hide-header="true"
        :hide-footer="true"
        size="lg"
        modal-class="d-sm-flex justify-content-sm-center align-items-sm-center"
      >
        <Deposit @closePopup="$bvModal.hide('deposit')" :CoinID="coinActive" />
      </b-modal>
      <b-modal
        id="withdraw"
        :hide-header="true"
        :hide-footer="true"
        size="lg"
        modal-class="d-sm-flex justify-content-sm-center align-items-sm-center"
      >
        <Withdraw
          @closePopup="$bvModal.hide('withdraw')"
          :CoinID="coinActive"
        />
      </b-modal>
      <b-modal
        id="transfer"
        :hide-header="true"
        :hide-footer="true"
        size="lg"
        modal-class="d-sm-flex justify-content-sm-center align-items-sm-center"
      >
        <Transfer
          @closePopup="$bvModal.hide('transfer')"
          :CoinID="coinActive"
        />
      </b-modal>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
.card-coin {
  .card-footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0;
    button {
      flex: 1 1 auto;
      margin: 10px 5px;
      max-width: 150px;
      width: max-content;
    }
  }
}
@media (min-width: 992px) and (max-width: 1800px) {
  .card-out-coin {
    flex: 0 0 50%;
  }
}
</style>
